<div
  (click)="checkLeaveLink($event)"
  class="leave-campaign-text"
  [innerHTML]="'partner.campaign.summary.leaveCampaignText' | translate"
></div>
